export default "__VITE_ASSET__ce386904__"